import axios from "axios";

const BASE = "/api/resources";

// Small service wrapper around the Resources browse endpoint. The generated
// OpenAPI client only exposes limit/offset (django-filter params aren't in
// the schema), so this calls the filter query params directly.
export const ResourcesApi = {
  async list({
    search,
    resource_type,
    is_free,
    tags,
    limit = 24,
    offset = 0,
  } = {}) {
    const params = { limit, offset, ordering: "-created" };
    if (search) params.title = search;
    if (resource_type) params.resource_type = resource_type;
    if (is_free !== undefined && is_free !== "") params.is_free = is_free;
    if (tags) params.tags = tags;
    const res = await axios.get(`${BASE}/`, { params, withCredentials: true });
    return res.data;
  },

  async tags() {
    const res = await axios.get("/api/tags/", { withCredentials: true });
    return res.data.results || res.data;
  },
};
